import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";

interface Return {
  qtd: number;
  interval: string;
}

export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [categories, setCategories] = useState<string[]>([]);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [qtd, setQtd] = useState<number[]>([]);
  const [indexTime, setIndexTime] = useState<number>(new Date().getHours());
  const [realTime, setIRealTime] = useState<string>("");
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    const time = new Date();
    setIndexTime(
      time.getHours() - parseInt(data.returns[0].interval.split("h")[0])
    );
    setIRealTime(time.getHours() + ":" + time.getMinutes());
    setQtd(
      data.returns.map(function (route: Return) {
        return route.qtd;
      })
    );
    setCategories(
      data.returns.map(function (route: Return) {
        return route.interval;
      })
    );
  }, [data]);

  useEffect(() => {
    if (qtd.length !== 0) {
      setTotal(
        qtd.reduce(function (soma: number, i: number) {
          return soma + i;
        })
      );
    }
  }, [qtd]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    colors: ["#01b8aa"],
    responsive: [
      {
        breakpoint: 480,
      },
    ],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        horizontal: true,
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        rotate: -90,
      },
    },
    yaxis: {
      max: Math.max(...qtd),
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
    annotations: {
      yaxis: [
        {
          y: categories[indexTime],
          borderColor: "#FFA510",
          label: {
            borderColor: "#FFA510",
            style: {
              fontSize: "12px",
              color: "#fff",
              background: "#FFA510",
              fontWeight: "bold",
            },
            orientation: "vertical",
            offsetY: 7,
            offsetX: -10,
            text: realTime,
          },
        },
      ],
    },
  };

  const series = [
    {
      name: "quantidade",
      data: qtd,
    },
  ];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-returns" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-returns", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Por horário: Aconteceram ${total} devoluções hoje`}
        id="chart-returns"
      />

      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
          clickable={componentProperty({
            id: "chartReturns",
            property: "redirect",
          })}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
